const RECENTLY_PRODUCT_HANDLE = 'recently_product_handle'
const MAX_LIMIT = 7

export const setRecentlyHandleProducts = (handle: string) => {
  if (handle) {
    let handles = getRecentlyHandleProducts()

    handles = handles.filter((item) => item !== handle)
    handles.unshift(handle)

    const newValue = handles.slice(0, MAX_LIMIT).join('|')

    localStorage.setItem(RECENTLY_PRODUCT_HANDLE, newValue)
  }
}

export const getRecentlyHandleProducts = () => {
  const localStorageValue = localStorage.getItem(RECENTLY_PRODUCT_HANDLE) || ''
  return localStorageValue.length ? localStorageValue.split('|') : []
}
